import { TLatestRequest } from 'Components/LatestRequests/LatestRequests.helpers';

const VIN_STRING = 'Numer VIN';

// Important - remove these after fixing masking function on BE
export const removeVINQuestionFromRequests = (requests: TLatestRequest[]): TLatestRequest[] => {
  return requests.map((request) => ({
    ...request,
    details: request.details.filter((detail) => !detail.question.includes(VIN_STRING)),
  }));
};
